class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.headerEl = document.querySelector('header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.isFixed = false;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  onScroll = () => {
    if (window.scrollY < this.headerEl.offsetHeight) {
      if (!this.isFixed) return;
      this.isFixed = false;
      this.notification.style.position = 'absolute';
      this.notification.style.top = 'initial';
    } else {
      if (this.isFixed) return;
      this.isFixed = true;
      this.notification.style.position = 'fixed';
      this.notification.style.top = '18px';
      // const notificationElStyles = this.notification.getBoundingClientRect()
      // this.notification.style.top = notificationElStyles.top;
      // this.notification.style.right = notificationElStyles.right;
    }
  };

  open = () => {
    this.notification.classList.add('animate', 'active');

    window.addEventListener('scroll', this.onScroll);
    this.onScroll();

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    window.removeEventListener('scroll', this.onScroll);

    // removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
